import { schema } from 'normalizr';

export const ENTITY_LEAD_SOURCES = 'leadSources';
export const ENTITY_LEAD_SOURCES_LIST = 'leadSourcesList';

export const leadSourcesSchema = new schema.Entity(ENTITY_LEAD_SOURCES, {}, { idAttribute: 'uuid' });
export const leadSourcesListSchema = new schema.Entity(ENTITY_LEAD_SOURCES_LIST, { data: [leadSourcesSchema] });
